var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contentData)?_c('div',{staticClass:"info-button"},[_c('button',{staticClass:"info-button__btn",on:{"click":_vm.toggleOverlay}}),(_vm.showOverlay)?_c('info-overlay',{staticClass:"info-button__overlay",attrs:{"contentData":_vm.contentData},on:{"close":_vm.toggleOverlay}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }